/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Manager, Reference, Popper } from "react-popper";
import { Portal } from "./Portal";
import { useTransition } from "react-spring";
import PropTypes from "prop-types";
export var Positioner = function Positioner(_a) {
  var target = _a.target,
      positionFixed = _a.positionFixed,
      _b = _a.isOpen,
      isOpen = _b === void 0 ? true : _b,
      children = _a.children,
      placement = _a.placement;
  var transitions = useTransition(isOpen, null, {
    from: {
      opacity: 1
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      mass: 1,
      tension: 185,
      friction: 26
    }
  });
  return jsx(Manager, null, jsx(Reference, null, target), transitions.map(function (_a) {
    var item = _a.item,
        key = _a.key,
        animatedProps = _a.props;
    return item && jsx(Portal, {
      key: key
    }, jsx(Popper, {
      placement: placement,
      positionFixed: positionFixed
    }, function (props) {
      return children(props, animatedProps);
    }));
  }));
};
Positioner.propTypes = {
  isOpen: PropTypes.bool,
  placement: PropTypes.oneOf(["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"]),
  positionFixed: PropTypes.bool,
  target: PropTypes.func,
  children: PropTypes.func
};